import {
  GESTION_OPERATIVA_SET_BON_ADICIONAL,
  GESTION_OPERATIVA_BON_ADICIONAL_ERROR,
  GESTION_OPERATIVA_SET_IS_MODIFIED,
} from './constants';
import { formatNumber } from 'Utilities'

export function setBonAdicional(bonAdicional) {
  return (dispatch, getState) => {
    // optionally you can have getState as the second argument
    // bonAdicional puede venir null o un valor
    const { gestionOperativa } = getState();
    const sale = gestionOperativa.sale;

    const precioTotal = sale.precioSubTotal - sale.bonificacionConcesionaria - sale.special_discount;

    if (bonAdicional > precioTotal) {
      dispatch({
        type: GESTION_OPERATIVA_BON_ADICIONAL_ERROR,
        data: {
          error: true,
          message: `El monto ingresado supera el límite de bonificación. Monto max: $${formatNumber.separator(precioTotal)}`
        }
      })
    } else if (bonAdicional < 0) {
      dispatch({
        type: GESTION_OPERATIVA_BON_ADICIONAL_ERROR,
        data: {
          error: true,
          message: 'El valor no puede ser menor a cero.'
        }
      })
    } else {
      dispatch(
        dispatch({
          type: GESTION_OPERATIVA_SET_BON_ADICIONAL,
          data: bonAdicional,
        }),
        dispatch({
          type: GESTION_OPERATIVA_SET_IS_MODIFIED,
          data: true
        })
      )
    }
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case GESTION_OPERATIVA_SET_BON_ADICIONAL:
      return {
        ...state,
        bonAdicionalError: false,
        sale: {
          ...state.sale,
          additional_discount: action.data,
        }
      }
    case GESTION_OPERATIVA_BON_ADICIONAL_ERROR:
      return {
        ...state,
        bonAdicionalError: action.data,
      }

    default:
      return state
  }
}
